import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: "2000"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackbarText), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_row, {
      class: "mt-5 mx-auto mb-5 playFairFont",
      align: "center",
      justify: "center",
      style: {"width":"60%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              variant: "text",
              class: "mx-auto",
              "max-width": "200",
              width: "200",
              href: "mailto:info@himzokucko.hu",
              style: {"text-align":"center"},
              height: "200",
              elevation: "5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-gmail",
                  color: "green",
                  size: "70"
                }),
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("div", {
                      style: {"text-align":"center"},
                      class: "font-weight-bold ms-1 mb-2"
                    }, "MAIL", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" info@himzokucko.hu ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              variant: "text",
              class: "mx-auto",
              "max-width": "200",
              width: "200",
              size: "70",
              href: "tel:+36 30 5705 139",
              style: {"text-align":"center"},
              height: "200",
              elevation: "5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-phone",
                  color: "orange",
                  size: "70"
                }),
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("div", {
                      style: {"text-align":"center"},
                      class: "font-weight-bold ms-1 mb-2"
                    }, "Mobil", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" +36 30 5705 139 ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              variant: "text",
              class: "mx-auto",
              "max-width": "200",
              width: "200",
              link: "",
              onClick: _ctx.onGoToFacebookClick,
              style: {"text-align":"center"},
              height: "200",
              elevation: "5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-facebook",
                  color: "blue",
                  size: "70"
                }),
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("div", {
                      style: {"text-align":"center"},
                      class: "font-weight-bold ms-1 mb-2"
                    }, "Facebook", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode(" www.facebook.com/"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode("kreativhimzokucko ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: {"text-align":"center"},
              variant: "text",
              class: "mx-auto",
              "max-width": "200",
              width: "200",
              height: "200",
              href: "http://maps.google.com/?q=6100 Kiskunfélegyháza Róna utca 17, Magyarország",
              elevation: "5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-map-marker",
                  color: "red",
                  size: "70"
                }),
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createElementVNode("div", {
                      style: {"text-align":"center"},
                      class: "font-weight-bold ms-1 mb-2"
                    }, "Telephely", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { style: {"text-align":"center"} }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" 6100 Kiskunfélegyháza, Róna utca 17. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}